import { render } from "./Upcoming.vue?vue&type=template&id=ab642cea"
import script from "./Upcoming.vue?vue&type=script&lang=js"
export * from "./Upcoming.vue?vue&type=script&lang=js"
script.render = render

export default script